interface BlockContextMenuProps {
  x: number
  y: number
  hasClipboard: boolean
  onEdit: () => void
  onCopy: () => void
  onCut: () => void
  onPaste: () => void
  onErase: () => void
  onEraseDay: () => void
  onClose: () => void
}

/**
 * Long-press menu, at the 500ms rung of the gesture ladder.
 *
 * Positioned near the finger but clamped inside the viewport, so a press near
 * the bottom of the screen does not open a menu that is half off it.
 */
export function BlockContextMenu({
  x,
  y,
  hasClipboard,
  onEdit,
  onCopy,
  onCut,
  onPaste,
  onErase,
  onEraseDay,
  onClose,
}: BlockContextMenuProps) {
  const MENU_WIDTH = 190
  const MENU_HEIGHT = hasClipboard ? 264 : 220

  const left = Math.min(Math.max(8, x - MENU_WIDTH / 2), window.innerWidth - MENU_WIDTH - 8)
  const top = Math.min(Math.max(8, y - MENU_HEIGHT - 12), window.innerHeight - MENU_HEIGHT - 8)

  return (
    <>
      <div className="ctx-scrim" onPointerDown={onClose} aria-hidden="true" />
      <div
        className="ctx-menu"
        style={{ left: `${left}px`, top: `${top}px`, width: `${MENU_WIDTH}px` }}
        role="menu"
      >
        <button className="ctx-item" role="menuitem" onClick={onEdit}>
          Edit block
        </button>
        <button className="ctx-item" role="menuitem" onClick={onCopy}>
          Copy
        </button>
        <button className="ctx-item" role="menuitem" onClick={onCut}>
          Cut
        </button>
        {hasClipboard ? (
          <button className="ctx-item" role="menuitem" onClick={onPaste}>
            Paste here
          </button>
        ) : null}
        <button className="ctx-item" role="menuitem" onClick={onErase}>
          Erase
        </button>
        <div className="ctx-sep" aria-hidden="true" />
        <button className="ctx-item ctx-item--danger" role="menuitem" onClick={onEraseDay}>
          Erase whole day
        </button>
      </div>
    </>
  )
}
